import { useEffect, useState } from "react";
import { getThumbnailView } from "../common_functions/http.services";
import { DirectoryIconGrayStyle } from "../icon_templates/icons";
import { AddFileIcon } from "./AddIconToNodes";
import {SingleInputModal} from "./SingleInputModal";
import { LoadingComponent } from "./LoadingComponent";
import * as bootstrap from 'bootstrap';
import { createNewCollection, create_new_folder } from "../assets/constants/global_apis";
import { get_all_collections, add_videos_to_collection, delete_files_from_folder, download_files } from "../assets/constants/global_apis";
import '../assets/styles/file_explorer_view.css';
import {
    faTrash,
    faDownload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { AlertMessageBox } from "./AlertMessage";
import MultiFileUploadWithBottomProgressBar from "./MultipleFileUploader";
import { ConfirmationModal } from "./ConfirmationModal";
import { decodeUrlEncodedString } from "../common_functions/video_annotator_functions";

export const FileExplorerView = (props) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        padding: '25px'
    };
    const { explorer_details, selected_backend_id, selectedPath, get_details_of_backends, selectedKey, selected_node, get_file_details, handleFolderViewChange, handleFileViewChange, handleRightClick } = props.data;
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [collections, setCollections] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [request, setRequest] = useState({
        label: ""
    });
    const [folderReq, setFolderReq] = useState({
        path: ""
    });
    const [showAlertBox, setShowAlertBox] = useState(false);
    // const [uploadedFiles, setUploadedFiles] = useState([])
    const [alertMessage, setAlertMessage] = useState({
        Errortype: "Error",
        title: "",
        message: "",
    });
    const [buttonAction, setbuttonAction] = useState({
        backend: {},
        event: 'Delete',
        index: -1,
        eventMessage: 'Do you want to Delete Selected Files?'
    })
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const handleOpenconfirmation = () => {
        setOpenConfirmation(true);
    };
    const handleCloseconfirmation = () => {
        setbuttonAction({
            backend: {},
            event: '',
            index: -1,
            eventMessage: ''
        });
        setOpenConfirmation(false);
    };


    const [open, setOpen] = useState(false);


    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setFolderReq({
            path: ""
        });
        setOpen(false);
    };

    const openAlertPopup = (errorType, title, message) => {
        setAlertMessage({
            Errortype: errorType,
            title: title,
            message: message,
        });
        setShowAlertBox(true);
        setTimeout(function () {
            setShowAlertBox(false);
        }, 2000);
    };


    const closeModal = () => {
        var myModalEl = document.getElementById('createCollectionModal');
        var modal = bootstrap.Modal.getInstance(myModalEl)
        modal.hide();
    }

    const create_new_collection = (event) => {
        event.preventDefault();
        createNewCollection(request).then(data => {
            closeModal();
            if(data?.id){
            add_files_to_collection(data.id);
            setRequest({
                label: ""
            });
            get_all_saved_collections(); // get_all_saved_collections();
        }
        })
    }
    const create_new_Folder = (event) => {
        event.preventDefault();
        let reqpayload = {
            path: `${selectedPath}/${folderReq.path}`
        }
        create_new_folder(selected_backend_id, reqpayload).then(data => {
            handleClose();
            setFolderReq({
                path: ""
            });
            if (selected_node.path == selectedPath) {
                get_details_of_backends(selected_backend_id, 1, selectedPath, selected_node.key); // get_all_saved_collections();
            } else {
                openAlertPopup("Error", "Path MisMatch", `Selected & Expanded Paths are different`);
            }
        })
    }

    const get_selected_files = (isDownload) => {

        const filteredLists = explorer_details.filter((node) => selectedFiles.includes(node.label));
        const finalLists = filteredLists.map((node) => {
            let data = {
                label: node.label,
                path: node.path,
                backendId: selected_backend_id,
            };
            if (isDownload) {
                data["is_dir"] = node.is_dir;
            }
            return data;
        })

        return finalLists;
    }

    const handleSelectedFiles = (e) => {
        let lists = [...selectedFiles];
        if (e.target.checked) {
            lists.push(e.target.value);
        } else {
            lists = lists.filter((item) => item !== e.target.value);
        }
        setSelectedFiles(lists);
    }
    const add_files_to_collection = (collectionId) => {
        let payload = get_selected_files()
        if(payload && payload.length>0){
        add_videos_to_collection(collectionId, payload).then(data => {
            openAlertPopup("Success", "Success", `Files added to collection.`);
        })
            .catch(error => console.log(error));
        }
    }

    const get_all_saved_collections = () => {
        get_all_collections().then(data => {
            setCollections(data);
        })
            .catch(error => console.log(error));
    }

    useEffect(() => {
        get_all_saved_collections();
    }, [])

    const handleDeleteFiles = () => {
        let payload = [...get_selected_files()].map((item, index) => {
            return { path: item.path }
        });
        if (payload.length > 0) {
            handleFolderViewChange();
            delete_files_from_folder(selected_backend_id, payload).then((data) => {
                setSelectedFiles([]);
                if (data?.deleted_files.length > 0) {
                    openAlertPopup("Success", "Success", `Files are deleted.`);
                    get_details_of_backends(selected_backend_id, 1, selectedPath, selected_node.key);
                    get_file_details(selected_backend_id, selectedPath)

                } else {
                    openAlertPopup("Error", "Delete Error", `Cannot Delete Folders`);
                }
                handleCloseconfirmation();
            });
        }
    }

    return (
        <>
            <span className="fileExplorerContainer" >
                <div className="container-fluid g-2">
                    <span>{decodeUrlEncodedString(selectedPath)}</span>

                    <div className="dropdown">
                        <button className="btn btn-dark dropdown-toggle create-folder-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Add to collection
                        </button>
                        <button className="btn collectionButtons create-folder-btn" type="button" onClick={handleOpen}>
                            Create New Folder
                        </button>
                        <MultiFileUploadWithBottomProgressBar backendId={selected_backend_id} selectedPath={selectedPath} openAlertPopup={openAlertPopup} get_file_details={get_file_details} get_details_of_backends={get_details_of_backends} selectedpathKey={selected_node?.key} />
                        <button disabled={get_selected_files().length == 0} className="btn collectionButtons delete-folder-btn" type="button" onClick={handleOpenconfirmation}>
                            <FontAwesomeIcon style={{ marginRight: '3px' }} icon={faTrash} />Delete
                        </button>
                        {
                            JSON.stringify(selectedFiles).includes('.mp4') &&
                            <button
                                onClick={() => {
                                    let files = get_selected_files(true);
                                    files = files.filter((item) => !item.is_dir);
                                    download_files(files);
                                }}
                                style={{ color: '#f8f9fa', background: '#212121' }} className="btn collectionButtons delete-folder-btn" type="button" >
                                <FontAwesomeIcon icon={faDownload} />
                            </button>
                        }


                        <ul className="dropdown-menu">
                            {
                                collections && collections.length>0 && collections.map((collection, index) => (
                                    <li key={index}>
                                        <button
                                            className={selectedFiles.length === 0 ? 'dropdown-item disabled' : 'dropdown-item'}
                                            onClick={() => add_files_to_collection(collection.id)}
                                        >
                                            {collection.label}
                                        </button>
                                    </li>
                                ))
                            }

                            <li><hr className="dropdown-divider" /></li>
                            <li><button className="dropdown-item" data-bs-toggle="modal" data-bs-target="#createCollectionModal">Create new collection</button></li>
                        </ul>
                    </div>
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-2" onContextMenu={(e) => {
                        handleRightClick(e, true, get_selected_files(true).filter((item, index) => !item.is_dir));
                    }}>
                        {
                            explorer_details.length > 0 ?
                                explorer_details.map((node, index) => (
                                    <div className="col" key={index}>
                                        <div className="form-check position-relative">
                                            <input className="form-check-input file-checkbox" type="checkbox" name="files" onChange={handleSelectedFiles} value={node.label} id={"fileExplorerCheck-" + index} />
                                            <label className="form-check-label d-flex flex-column" htmlFor={"fileExplorerCheck-" + index}>
                                                <div className="card bg-transparent mt-1 exp-direc" tabIndex={index} >
                                                    <div className="card-body p-1">
                                                        <div className="text-center" title={node.label.replace("/", "")}>
                                                            {
                                                                node.is_dir ?
                                                                    <DirectoryIconGrayStyle IconStyleClass="svg-file-explorer-icon" /> :
                                                                    AddFileIcon(node.label, "svg-file-explorer-icon")
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="card-footer bg-transparent border-0 text-center">
                                                        <div style={{ "fontSize": '0.825rem', width: "100%", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: 'hidden' }} title={node.label.replace("/", "")}>{node.label.replace("/", "")}</div>
                                                    </div>
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                )) : 'No data available'
                        }
                    </div>
                </div>
                <SingleInputModal requestpayload={request} setRequestPayload={setRequest} handleSubmit={create_new_collection} handleClose={closeModal} popupType={'Collection'} />
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="child-modal-title"
                    aria-describedby="child-modal-description"
                >
                    <Box sx={{ ...style }}>
                        <div className="modal-header border-0">
                            <h1 className="modal-title fs-5" id="createCollectionModalLabel">Create Folder</h1>
                            {/* <button type="button" className="btn-close" onClick={handleClose}></button> */}
                        </div>
                        <div className="modal-body">
                            <form onSubmit={(e) => create_new_Folder(e)}>
                                <div className="mb-3">
                                    <label htmlFor="collectionName" className="form-label">New Folder name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="collectionName"
                                        placeholder={`Enter Folder name`}
                                        value={folderReq?.path}
                                        required
                                        autoComplete="c-name"
                                        onChange={(e) => setFolderReq({ path: e.target.value })}
                                    />
                                </div>

                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-sm btn-outline-secondary me-2" onClick={handleClose}>Close</button>
                                    <button className="btn btn-sm btn-primary" type="submit">Create Folder</button>
                                </div>
                            </form>
                        </div>
                    </Box>
                </Modal>

                <ConfirmationModal isThisCenterAligned={true} buttonAction={buttonAction} open={openConfirmation} handleClose={handleCloseconfirmation} handleSubmitConfirmation={handleDeleteFiles} />
                <div className="fileViewAlertcontainer">
                    <AlertMessageBox
                        showAlertBox={showAlertBox}
                        setShowAlertBox={setShowAlertBox}
                        alertMessage={alertMessage}
                    />
                </div>
                {isLoading && <LoadingComponent />}

            </span>
        </>
    )
}